module.exports = __webpack_public_path__ + "img/kpyyzz.ba0ce291.png";